import { IS_SERVER } from './checkRenderEnv';

const checkIfWebview = () => {
  return !IS_SERVER && !!window.ReactNativeWebView;
};

export default checkIfWebview;
